/**
 * BriqueChart의 Mode Bar 관련 기능 구현
 */

import BriqueChart from './BriqueChart.vue'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
  // TODO: 현재 다국어 적용으로 인하여 아래 항목은 사용하지 않음 (기존에 사용했던 항목)
  // MODE_BAR_BUTTONS: [[
  //   'resetScale2d', // Scale을 리셋한다.
  //   'zoom2d', // Zoom Mode(드래그시 Zoom In)
  //   'pan2d', // Pan Mode(드래그시 이동)
  //   'select2d', // Select Mode(드래그시 선택), mode가 lines일때는 동작하지 않음
  //   'lasso2d', // Select Mode(드래그시 선택)
  //   {
  //     title: 'Tooltip Mode - On mouse over', // 나중에 메시지 처리할 것
  //     val: 'tooltip.mode.hover',
  //     name: 'tooltip.mode.hover',
  //     attr: 'tooltip_mode_hover', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     visible: true, // custom
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M4 0l16 12.279-6.78 1.138 4.256 8.676-3.902 1.907-4.281-8.758-5.293 4.581z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickTooltipMode(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Tooltip Mode - Click', // 나중에 메시지 처리할 것
  //     name: 'tooltip.mode.click',
  //     val: 'tooltip.mode.click',
  //     attr: 'tooltip_mode_click', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     visible: false, // custom
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M13.807 8.771l4.768-3.302-1.415-2.042c-.644-.928-1.678-1.427-2.727-1.427-.651 0-1.309.191-1.884.59l-2.045 1.415 3.303 4.766zm-5.184 5.609l3.302 4.767c1.286 1.857 3.353 2.853 5.452 2.853 3.628 0 6.623-2.944 6.623-6.634 0-1.302-.383-2.617-1.181-3.768l-3.301-4.765-10.895 7.547zm.52-9.431l-2.04 1.416c-1.506 1.042-1.881 3.106-.838 4.61l1.413 2.043 4.768-3.302-3.303-4.767zm-1.646 5.171c-.57-.823-.369-1.948.461-2.522l.807-.56 1.593 2.299-2.3 1.593-.561-.81zm-3.321-2.231l-2.499-1.74.62-.891 2.271 1.582c-.169.332-.3.681-.392 1.049zm.702 4.006l-2.299 1.615-.624-.888 2.414-1.699c.135.338.299.665.509.972zm-.778-1.906h-3.1v-1.085h3.029c-.013.366.005.729.071 1.085z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickTooltipMode(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Tooltip Mode - None', // 나중에 메시지 처리할 것
  //     name: 'tooltip.mode.none',
  //     val: 'tooltip.mode.none',
  //     attr: 'tooltip_mode_none', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     visible: false, // custom
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M14 14.655l-5.799.908 3.393 6.917-3.112 1.52-3.412-6.982-4.07 3.651v-15.857l13 9.843zm3-14.655c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zm-4 6c0-.739.215-1.424.567-2.019l5.453 5.453c-.595.351-1.28.566-2.02.566-2.206 0-4-1.794-4-4zm7.434 2.02l-5.453-5.453c.595-.352 1.28-.567 2.019-.567 2.206 0 4 1.794 4 4 0 .74-.215 1.424-.566 2.02z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickTooltipMode(this, ...arguments)
  //     }
  //   },
  //   'hoverClosestCartesian',
  //   'hoverCompareCartesian',
  //   {
  //     title: 'Copy tooltip to clipboard', // 나중에 메시지 처리할 것
  //     name: 'copyTooltip',
  //     val: 'copyTooltip',
  //     attr: 'copyTooltip', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     visible: true, // custom
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M7 16h10v1h-10v-1zm0-1h10v-1h-10v1zm15-13v22h-20v-22h3c1.229 0 2.18-1.084 3-2h8c.82.916 1.771 2 3 2h3zm-11 1c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1zm9 1h-4l-2 2h-3.898l-2.102-2h-4v18h16v-18zm-13 9h10v-1h-10v1zm0-2h10v-1h-10v1z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickHoverCompareCartesian(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Legend Position', // 나중에 메시지 처리할 것을
  //     name: 'changelegendPosition',
  //     val: 'changelegendPosition',
  //     attr: 'changelegendPosition', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M4 22h-4v-4h4v4zm0-12h-4v4h4v-4zm0-8h-4v4h4v-4zm3 0v4h17v-4h-17zm0 12h17v-4h-17v4zm0 8h17v-4h-17v4z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickChangeLegendPosition(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: '모든 데이터가 표시되고 있습니다. 데이터를 Sampling 하시려면 클릭하세요.', // 나중에 메시지 처리할 것
  //     name: 'samplingData',
  //     val: 'samplingData',
  //     attr: 'samplingData', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     active: false, // custom, false : 모든 데이터 표시중, true : Sample Data 표시중
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm2.255 8.852c-.003 1.684-2.484 2.059-2.925.812-.333-.945.797-1.947 1.926-1.725v-2.912l-4.001.955v3.469c-.001 1.682-2.5 2.059-2.94.811-.334-.944.813-1.948 1.941-1.723v-4.344l5.999-1.195v5.852zm-1.431-16.777c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickSamplingData(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Range View', // 나중에 메시지 처리할 것
  //     name: 'rangeView',
  //     val: 'rangeView',
  //     attr: 'rangeView', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     active: false, // Custom, true : Range View
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M5.829 21c-.412 1.165-1.524 2-2.829 2-1.656 0-3-1.344-3-3s1.344-3 3-3c1.305 0 2.417.835 2.829 2h3.342c.412-1.165 1.524-2 2.829-2 1.305 0 2.417.835 2.829 2h3.342c.412-1.165 1.524-2 2.829-2 1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.305 0-2.417-.835-2.829-2h-3.342c-.412 1.165-1.524 2-2.829 2-1.305 0-2.417-.835-2.829-2h-3.342zm6.171-2c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm0-18c-2.624 0-5 2.127-5 4.751 0 2.624 2.168 5.756 5 10.249 2.832-4.493 5-7.625 5-10.249 0-2.624-2.376-4.751-5-4.751zm0 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z'
  //     },
  //     click: async function (element, e) {
  //       BriqueChart.onClickRangeView(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: '팔레트 선택', // 나중에 메시지 처리할 것
  //     name: 'selectPalette',
  //     val: 'selectPalette',
  //     attr: 'selectPalette', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M10.5 24h-7c-1.4 0-2.5-1.14-2.5-2.5v-11.64c-.662-.473-1-1.201-1-1.941 0-.376.089-.75.289-1.129 1.065-1.898 2.153-3.783 3.265-5.654.462-.737 1.211-1.136 2.045-1.136.635 0 .972.204 1.445.479.662.386 9 5.352 12.512 7.441.087.052 3.366 1.988 3.449 2.045.663.49.995 1.197.995 1.934 0 .375-.092.745-.295 1.13-1.064 1.899-2.153 3.784-3.265 5.655-.577.92-1.615 1.29-2.496 1.088-.392.234-5.826 3.75-6.252 3.968-.413.212-.762.26-1.192.26m-7.5-10.763v8.263c0 .274.221.5.5.5h4.588c-1.72-2.906-3.417-5.827-5.088-8.763m1.606-1.238c.053.092 5.681 9.797 5.726 9.859.108.139.299.181.455.098.164-.092 5.081-3.251 5.081-3.251-.639-.377-8.144-4.851-11.262-6.706m.659-9.829c-.913 1.456-3.199 5.525-3.235 5.61-.07.171-.008.366.149.464.201.12 16.023 9.547 16.177 9.571.151.022.297-.045.377-.174.942-1.584 3.206-5.55 3.232-5.601.069-.172.007-.367-.15-.465-.201-.12-15.983-9.499-16.09-9.546-.18-.074-.365-.002-.46.141m1.557 2.695c1.104 0 2 .897 2 2 0 1.104-.896 2-2 2s-2-.896-2-2c0-1.103.896-2 2-2M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm2.255 8.852c-.003 1.684-2.484 2.059-2.925.812-.333-.945.797-1.947 1.926-1.725v-2.912l-4.001.955v3.469c-.001 1.682-2.5 2.059-2.94.811-.334-.944.813-1.948 1.941-1.723v-4.344l5.999-1.195v5.852zm-1.431-16.777c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.openChartModal(element, 'palette')
  //     }
  //   },
  //   {
  //     title: 'Copy image to clipboard', // 나중에 메시지 처리할 것
  //     name: 'copyImageToClipboard',
  //     val: 'copyImageToClipboard',
  //     attr: 'copyImageToClipboard', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M5 8.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5zm9 .5l-2.519 4-2.481-1.96-4 5.96h14l-5-8zm8-4v14h-20v-14h20zm2-2h-24v18h24v-18z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickCopyImageToClipboard(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Data Grid', // 나중에 메시지 처리할 것
  //     name: 'chartDataGrid',
  //     val: 'chartDataGrid',
  //     attr: 'chartDataGrid', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 512,
  //       height: 512,
  //       // transform: 'translate(0, 0)',
  //       // path: 'M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M13 12L16.2 17H14.2L12 13.2L9.8 17H7.8L11 12L7.8 7H9.8L12 10.8L14.2 7H16.2L13 12Z' // Excel icon
  //       path: 'M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM224 256V160H64V256H224zM64 320V416H224V320H64zM288 416H448V320H288V416zM448 256V160H288V256H448z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.openChartModalDataGrid(element)
  //     }
  //   },
  //   {
  //     title: 'Export Csv', // 나중에 메시지 처리할 것
  //     name: 'csvExport',
  //     val: 'csvExport',
  //     attr: 'csvExport', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 384,
  //       height: 512,
  //       path: 'M224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM80 224C57.91 224 40 241.9 40 264V344C40 366.1 57.91 384 80 384H96C118.1 384 136 366.1 136 344V336C136 327.2 128.8 320 120 320C111.2 320 104 327.2 104 336V344C104 348.4 100.4 352 96 352H80C75.58 352 72 348.4 72 344V264C72 259.6 75.58 256 80 256H96C100.4 256 104 259.6 104 264V272C104 280.8 111.2 288 120 288C128.8 288 136 280.8 136 272V264C136 241.9 118.1 224 96 224H80zM175.4 310.6L200.8 325.1C205.2 327.7 208 332.5 208 337.6C208 345.6 201.6 352 193.6 352H168C159.2 352 152 359.2 152 368C152 376.8 159.2 384 168 384H193.6C219.2 384 240 363.2 240 337.6C240 320.1 231.1 305.6 216.6 297.4L191.2 282.9C186.8 280.3 184 275.5 184 270.4C184 262.4 190.4 256 198.4 256H216C224.8 256 232 248.8 232 240C232 231.2 224.8 224 216 224H198.4C172.8 224 152 244.8 152 270.4C152 287 160.9 302.4 175.4 310.6zM280 240C280 231.2 272.8 224 264 224C255.2 224 248 231.2 248 240V271.6C248 306.3 258.3 340.3 277.6 369.2L282.7 376.9C285.7 381.3 290.6 384 296 384C301.4 384 306.3 381.3 309.3 376.9L314.4 369.2C333.7 340.3 344 306.3 344 271.6V240C344 231.2 336.8 224 328 224C319.2 224 312 231.2 312 240V271.6C312 294.6 306.5 317.2 296 337.5C285.5 317.2 280 294.6 280 271.6V240zM256 0L384 128H256V0z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.onClickExportCsv(element)
  //     }
  //   },
  //   {
  //     title: 'Chart Split', // 나중에 메시지 처리할 것
  //     name: 'chartSplit',
  //     val: 'chartSplit',
  //     attr: 'chartSplit', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 24,
  //       height: 24,
  //       // transform: 'translate(0, 0)',
  //       path: 'M3 20c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm9 2c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm0-18c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm9 20c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm-1.577-1.721l-6.423-5.028v-3.352c-.323.066-.658.101-1 .101s-.677-.035-1-.101v3.352l-6.424 5.028c.695.233 1.323.602 1.844 1.093l5.58-4.372 5.579 4.373c.522-.492 1.15-.861 1.844-1.094z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.openChartModal(element, 'split')
  //     }
  //   },
  //   {
  //     title: 'X축 데이터 선택', // 나중에 메시지 처리할 것
  //     name: 'xAxisDataSelection',
  //     val: 'xAxisDataSelection',
  //     attr: 'xAxisDataSelection', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 384,
  //       height: 512,
  //       // transform: 'translate(0, 0)',
  //       // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
  //       path: 'M376.6 427.5c11.31 13.58 9.484 33.75-4.094 45.06c-5.984 4.984-13.25 7.422-20.47 7.422c-9.172 0-18.27-3.922-24.59-11.52L192 305.1l-135.4 162.5c-6.328 7.594-15.42 11.52-24.59 11.52c-7.219 0-14.48-2.438-20.47-7.422c-13.58-11.31-15.41-31.48-4.094-45.06l142.9-171.5L7.422 84.5C-3.891 70.92-2.063 50.75 11.52 39.44c13.56-11.34 33.73-9.516 45.06 4.094L192 206l135.4-162.5c11.3-13.58 31.48-15.42 45.06-4.094c13.58 11.31 15.41 31.48 4.094 45.06l-142.9 171.5L376.6 427.5z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.openChartModal(element, 'xAxisDataSelection')
  //     }
  //   },
  //   {
  //     title: 'Y축 Primary / Secondary 선택', // 나중에 메시지 처리할 것
  //     name: 'yAxisPrimarySecondarySelection',
  //     val: 'yAxisPrimarySecondarySelection',
  //     attr: 'yAxisPrimarySecondarySelection', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 384,
  //       height: 512,
  //       // transform: 'translate(0, 0)',
  //       // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
  //       path: 'M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.openChartModal(element, 'yAxisPrimarySecondarySelection')
  //     }
  //   },
  //   {
  //     title: '데이터 정규화', // 나중에 메시지 처리할 것
  //     name: 'dataNormalization',
  //     val: 'dataNormalization',
  //     attr: 'dataNormalization', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 576,
  //       height: 512,
  //       // transform: 'translate(0, 0)',
  //       // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
  //       // path: 'M416 208C416 253.9 401.1 296.3 375.1 330.7L502.6 457.4C515.1 469.9 515.1 490.1 502.6 502.6C490.1 515.1 469.9 515.1 457.4 502.6L330.7 375.1C296.3 401.1 253.9 416 208 416C93.12 416 0 322.9 0 208C0 93.12 93.12 0 208 0C322.9 0 416 93.12 416 208zM104 280C104 293.3 114.7 304 128 304C141.3 304 152 293.3 152 280V216C152 202.7 141.3 192 128 192C114.7 192 104 202.7 104 216V280zM184 280C184 293.3 194.7 304 208 304C221.3 304 232 293.3 232 280V120C232 106.7 221.3 96 208 96C194.7 96 184 106.7 184 120V280zM264 280C264 293.3 274.7 304 288 304C301.3 304 312 293.3 312 280V184C312 170.7 301.3 160 288 160C274.7 160 264 170.7 264 184V280z' // 돋보기
  //       path: 'M41.37 406.6C28.88 394.1 28.88 373.9 41.37 361.4C53.87 348.9 74.13 348.9 86.63 361.4L128 402.7V287.1H32C14.33 287.1 0 273.7 0 255.1C0 238.3 14.33 223.1 32 223.1H384V109.3L342.6 150.6C330.1 163.1 309.9 163.1 297.4 150.6C284.9 138.1 284.9 117.9 297.4 105.4L393.4 9.372C405.9-3.124 426.1-3.124 438.6 9.372L534.6 105.4C547.1 117.9 547.1 138.1 534.6 150.6C522.1 163.1 501.9 163.1 489.4 150.6L448 109.3V223.1H544C561.7 223.1 576 238.3 576 255.1C576 273.7 561.7 287.1 544 287.1H192V402.7L233.4 361.4C245.9 348.9 266.1 348.9 278.6 361.4C291.1 373.9 291.1 394.1 278.6 406.6L182.6 502.6C170.1 515.1 149.9 515.1 137.4 502.6L41.37 406.6zM128 63.1C128 46.33 142.3 31.1 160 31.1C177.7 31.1 192 46.33 192 63.1V191.1H128V63.1zM448 319.1V448C448 465.7 433.7 480 416 480C398.3 480 384 465.7 384 448V319.1H448z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       BriqueChart.onClickDataNormalization(this, ...arguments)
  //     }
  //   },
  //   {
  //     title: 'Help',
  //     name: 'help',
  //     val: 'help',
  //     attr: 'help', // attr이 있어야 Plotly가 active를 잘 적용한다.
  //     icon: {
  //       width: 320,
  //       height: 512,
  //       path: 'M204.3 32.01H96c-52.94 0-96 43.06-96 96c0 17.67 14.31 31.1 32 31.1s32-14.32 32-31.1c0-17.64 14.34-32 32-32h108.3C232.8 96.01 256 119.2 256 147.8c0 19.72-10.97 37.47-30.5 47.33L127.8 252.4C117.1 258.2 112 268.7 112 280v40c0 17.67 14.31 31.99 32 31.99s32-14.32 32-31.99V298.3L256 251.3c39.47-19.75 64-59.42 64-103.5C320 83.95 268.1 32.01 204.3 32.01zM144 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S166.1 400 144 400z'
  //     },
  //     click: function (element, e) {
  //       BriqueChart.restyleModeBarButtons(element)
  //       // TODO: 추후 제거될 toast
  //       Toast.open({
  //         message: `Help에 대한 내용 정의 후 개발이 필요합니다.`,
  //         type: 'is-warning',
  //         queue: false
  //       })
  //       // BriqueChart.onClickDataNormalization(this, ...arguments)
  //     }
  //   }
  // ]],

  /**
  * Modebar Button 조회
  * @param {*} element chart element
  * @returns modebar button 배열
  */
  getModeBarButtons (element) {
    return [[
      'resetScale2d', // Scale을 리셋한다.
      'zoom2d', // Zoom Mode(드래그시 Zoom In)
      'pan2d', // Pan Mode(드래그시 이동)
      'select2d', // Select Mode(드래그시 선택), mode가 lines일때는 동작하지 않음
      'lasso2d', // Select Mode(드래그시 선택)
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.TOOLTIP_MOUSEOVER'),
        val: 'tooltip.mode.hover',
        name: 'tooltip.mode.hover',
        attr: 'tooltip_mode_hover', // attr이 있어야 Plotly가 active를 잘 적용한다.
        visible: true, // custom
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M4 0l16 12.279-6.78 1.138 4.256 8.676-3.902 1.907-4.281-8.758-5.293 4.581z'
        },
        click: function (element, e) {
          BriqueChart.onClickTooltipMode(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.TOOLTIP_CLICK'),
        name: 'tooltip.mode.click',
        val: 'tooltip.mode.click',
        attr: 'tooltip_mode_click', // attr이 있어야 Plotly가 active를 잘 적용한다.
        visible: false, // custom
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M13.807 8.771l4.768-3.302-1.415-2.042c-.644-.928-1.678-1.427-2.727-1.427-.651 0-1.309.191-1.884.59l-2.045 1.415 3.303 4.766zm-5.184 5.609l3.302 4.767c1.286 1.857 3.353 2.853 5.452 2.853 3.628 0 6.623-2.944 6.623-6.634 0-1.302-.383-2.617-1.181-3.768l-3.301-4.765-10.895 7.547zm.52-9.431l-2.04 1.416c-1.506 1.042-1.881 3.106-.838 4.61l1.413 2.043 4.768-3.302-3.303-4.767zm-1.646 5.171c-.57-.823-.369-1.948.461-2.522l.807-.56 1.593 2.299-2.3 1.593-.561-.81zm-3.321-2.231l-2.499-1.74.62-.891 2.271 1.582c-.169.332-.3.681-.392 1.049zm.702 4.006l-2.299 1.615-.624-.888 2.414-1.699c.135.338.299.665.509.972zm-.778-1.906h-3.1v-1.085h3.029c-.013.366.005.729.071 1.085z'
        },
        click: function (element, e) {
          BriqueChart.onClickTooltipMode(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.TOOLTIP_NONE'),
        name: 'tooltip.mode.none',
        val: 'tooltip.mode.none',
        attr: 'tooltip_mode_none', // attr이 있어야 Plotly가 active를 잘 적용한다.
        visible: false, // custom
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M14 14.655l-5.799.908 3.393 6.917-3.112 1.52-3.412-6.982-4.07 3.651v-15.857l13 9.843zm3-14.655c-3.313 0-6 2.687-6 6s2.687 6 6 6 6-2.687 6-6-2.686-6-6-6zm-4 6c0-.739.215-1.424.567-2.019l5.453 5.453c-.595.351-1.28.566-2.02.566-2.206 0-4-1.794-4-4zm7.434 2.02l-5.453-5.453c.595-.352 1.28-.567 2.019-.567 2.206 0 4 1.794 4 4 0 .74-.215 1.424-.566 2.02z'
        },
        click: function (element, e) {
          BriqueChart.onClickTooltipMode(this, ...arguments)
        }
      },
      'hoverClosestCartesian',
      'hoverCompareCartesian',
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.COPY_TOOLTIP'),
        name: 'copyTooltip',
        val: 'copyTooltip',
        attr: 'copyTooltip', // attr이 있어야 Plotly가 active를 잘 적용한다.
        visible: true, // custom
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M7 16h10v1h-10v-1zm0-1h10v-1h-10v1zm15-13v22h-20v-22h3c1.229 0 2.18-1.084 3-2h8c.82.916 1.771 2 3 2h3zm-11 1c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1-1 .448-1 1zm9 1h-4l-2 2h-3.898l-2.102-2h-4v18h16v-18zm-13 9h10v-1h-10v1zm0-2h10v-1h-10v1z'
        },
        click: function (element, e) {
          BriqueChart.onClickHoverCompareCartesian(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.LEGEND_POSITION'),
        name: 'changelegendPosition',
        val: 'changelegendPosition',
        attr: 'changelegendPosition', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M4 22h-4v-4h4v4zm0-12h-4v4h4v-4zm0-8h-4v4h4v-4zm3 0v4h17v-4h-17zm0 12h17v-4h-17v4zm0 8h17v-4h-17v4z'
        },
        click: function (element, e) {
          BriqueChart.onClickChangeLegendPosition(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.SAMPLING_DATA'),
        name: 'samplingData',
        val: 'samplingData',
        attr: 'samplingData', // attr이 있어야 Plotly가 active를 잘 적용한다.
        active: false, // custom, false : 모든 데이터 표시중, true : Sample Data 표시중
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm2.255 8.852c-.003 1.684-2.484 2.059-2.925.812-.333-.945.797-1.947 1.926-1.725v-2.912l-4.001.955v3.469c-.001 1.682-2.5 2.059-2.94.811-.334-.944.813-1.948 1.941-1.723v-4.344l5.999-1.195v5.852zm-1.431-16.777c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z'
        },
        click: function (element, e) {
          BriqueChart.onClickSamplingData(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.RANGE_VIEW'),
        name: 'rangeView',
        val: 'rangeView',
        attr: 'rangeView', // attr이 있어야 Plotly가 active를 잘 적용한다.
        active: false, // Custom, true : Range View
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M5.829 21c-.412 1.165-1.524 2-2.829 2-1.656 0-3-1.344-3-3s1.344-3 3-3c1.305 0 2.417.835 2.829 2h3.342c.412-1.165 1.524-2 2.829-2 1.305 0 2.417.835 2.829 2h3.342c.412-1.165 1.524-2 2.829-2 1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.305 0-2.417-.835-2.829-2h-3.342c-.412 1.165-1.524 2-2.829 2-1.305 0-2.417-.835-2.829-2h-3.342zm6.171-2c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm0-18c-2.624 0-5 2.127-5 4.751 0 2.624 2.168 5.756 5 10.249 2.832-4.493 5-7.625 5-10.249 0-2.624-2.376-4.751-5-4.751zm0 7c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z'
        },
        click: async function (element, e) {
          BriqueChart.onClickRangeView(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.PALETTE'),
        name: 'selectPalette',
        val: 'selectPalette',
        attr: 'selectPalette', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M10.5 24h-7c-1.4 0-2.5-1.14-2.5-2.5v-11.64c-.662-.473-1-1.201-1-1.941 0-.376.089-.75.289-1.129 1.065-1.898 2.153-3.783 3.265-5.654.462-.737 1.211-1.136 2.045-1.136.635 0 .972.204 1.445.479.662.386 9 5.352 12.512 7.441.087.052 3.366 1.988 3.449 2.045.663.49.995 1.197.995 1.934 0 .375-.092.745-.295 1.13-1.064 1.899-2.153 3.784-3.265 5.655-.577.92-1.615 1.29-2.496 1.088-.392.234-5.826 3.75-6.252 3.968-.413.212-.762.26-1.192.26m-7.5-10.763v8.263c0 .274.221.5.5.5h4.588c-1.72-2.906-3.417-5.827-5.088-8.763m1.606-1.238c.053.092 5.681 9.797 5.726 9.859.108.139.299.181.455.098.164-.092 5.081-3.251 5.081-3.251-.639-.377-8.144-4.851-11.262-6.706m.659-9.829c-.913 1.456-3.199 5.525-3.235 5.61-.07.171-.008.366.149.464.201.12 16.023 9.547 16.177 9.571.151.022.297-.045.377-.174.942-1.584 3.206-5.55 3.232-5.601.069-.172.007-.367-.15-.465-.201-.12-15.983-9.499-16.09-9.546-.18-.074-.365-.002-.46.141m1.557 2.695c1.104 0 2 .897 2 2 0 1.104-.896 2-2 2s-2-.896-2-2c0-1.103.896-2 2-2M13.744 8s1.522-8-3.335-8h-8.409v24h20v-13c0-3.419-5.247-3.745-8.256-3zm2.255 8.852c-.003 1.684-2.484 2.059-2.925.812-.333-.945.797-1.947 1.926-1.725v-2.912l-4.001.955v3.469c-.001 1.682-2.5 2.059-2.94.811-.334-.944.813-1.948 1.941-1.723v-4.344l5.999-1.195v5.852zm-1.431-16.777c2.202 1.174 5.938 4.883 7.432 6.881-1.286-.9-4.044-1.657-6.091-1.179.222-1.468-.185-4.534-1.341-5.702z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.openChartModal(element, 'palette')
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.COPY_IMAGE'),
        name: 'copyImageToClipboard',
        val: 'copyImageToClipboard',
        attr: 'copyImageToClipboard', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M5 8.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5zm9 .5l-2.519 4-2.481-1.96-4 5.96h14l-5-8zm8-4v14h-20v-14h20zm2-2h-24v18h24v-18z'
        },
        click: function (element, e) {
          BriqueChart.onClickCopyImageToClipboard(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.DATA_GRID'),
        name: 'chartDataGrid',
        val: 'chartDataGrid',
        attr: 'chartDataGrid', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 512,
          height: 512,
          // transform: 'translate(0, 0)',
          // path: 'M5 3C3.89 3 3 3.89 3 5V19C3 20.11 3.89 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.89 20.11 3 19 3H5M5 5H19V19H5V5M13 12L16.2 17H14.2L12 13.2L9.8 17H7.8L11 12L7.8 7H9.8L12 10.8L14.2 7H16.2L13 12Z' // Excel icon
          path: 'M448 32C483.3 32 512 60.65 512 96V416C512 451.3 483.3 480 448 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H448zM224 256V160H64V256H224zM64 320V416H224V320H64zM288 416H448V320H288V416zM448 256V160H288V256H448z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.openChartModalDataGrid(element)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.EXPORT_CSV'),
        name: 'csvExport',
        val: 'csvExport',
        attr: 'csvExport', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 384,
          height: 512,
          path: 'M224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM80 224C57.91 224 40 241.9 40 264V344C40 366.1 57.91 384 80 384H96C118.1 384 136 366.1 136 344V336C136 327.2 128.8 320 120 320C111.2 320 104 327.2 104 336V344C104 348.4 100.4 352 96 352H80C75.58 352 72 348.4 72 344V264C72 259.6 75.58 256 80 256H96C100.4 256 104 259.6 104 264V272C104 280.8 111.2 288 120 288C128.8 288 136 280.8 136 272V264C136 241.9 118.1 224 96 224H80zM175.4 310.6L200.8 325.1C205.2 327.7 208 332.5 208 337.6C208 345.6 201.6 352 193.6 352H168C159.2 352 152 359.2 152 368C152 376.8 159.2 384 168 384H193.6C219.2 384 240 363.2 240 337.6C240 320.1 231.1 305.6 216.6 297.4L191.2 282.9C186.8 280.3 184 275.5 184 270.4C184 262.4 190.4 256 198.4 256H216C224.8 256 232 248.8 232 240C232 231.2 224.8 224 216 224H198.4C172.8 224 152 244.8 152 270.4C152 287 160.9 302.4 175.4 310.6zM280 240C280 231.2 272.8 224 264 224C255.2 224 248 231.2 248 240V271.6C248 306.3 258.3 340.3 277.6 369.2L282.7 376.9C285.7 381.3 290.6 384 296 384C301.4 384 306.3 381.3 309.3 376.9L314.4 369.2C333.7 340.3 344 306.3 344 271.6V240C344 231.2 336.8 224 328 224C319.2 224 312 231.2 312 240V271.6C312 294.6 306.5 317.2 296 337.5C285.5 317.2 280 294.6 280 271.6V240zM256 0L384 128H256V0z'
        },
        click: function (element, e) {
          BriqueChart.onClickExportCsv(element)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.SPLIT_CHART'),
        name: 'chartSplit',
        val: 'chartSplit',
        attr: 'chartSplit', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 24,
          height: 24,
          // transform: 'translate(0, 0)',
          path: 'M3 20c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm9 2c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm0-18c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm9 20c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0-2c-1.656 0-3 1.343-3 3s1.344 3 3 3 3-1.343 3-3-1.344-3-3-3zm-1.577-1.721l-6.423-5.028v-3.352c-.323.066-.658.101-1 .101s-.677-.035-1-.101v3.352l-6.424 5.028c.695.233 1.323.602 1.844 1.093l5.58-4.372 5.579 4.373c.522-.492 1.15-.861 1.844-1.094z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.openChartModal(element, 'split')
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.X_AXIS'),
        name: 'xAxisDataSelection',
        val: 'xAxisDataSelection',
        attr: 'xAxisDataSelection', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 384,
          height: 512,
          // transform: 'translate(0, 0)',
          // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
          path: 'M376.6 427.5c11.31 13.58 9.484 33.75-4.094 45.06c-5.984 4.984-13.25 7.422-20.47 7.422c-9.172 0-18.27-3.922-24.59-11.52L192 305.1l-135.4 162.5c-6.328 7.594-15.42 11.52-24.59 11.52c-7.219 0-14.48-2.438-20.47-7.422c-13.58-11.31-15.41-31.48-4.094-45.06l142.9-171.5L7.422 84.5C-3.891 70.92-2.063 50.75 11.52 39.44c13.56-11.34 33.73-9.516 45.06 4.094L192 206l135.4-162.5c11.3-13.58 31.48-15.42 45.06-4.094c13.58 11.31 15.41 31.48 4.094 45.06l-142.9 171.5L376.6 427.5z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.openChartModal(element, 'xAxisDataSelection')
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.Y_AXIS'),
        name: 'yAxisPrimarySecondarySelection',
        val: 'yAxisPrimarySecondarySelection',
        attr: 'yAxisPrimarySecondarySelection', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 384,
          height: 512,
          // transform: 'translate(0, 0)',
          // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
          path: 'M378 82.61L224 298.3v149.8c0 17.67-14.31 31.1-32 31.1S160 465.7 160 448V298.3L5.969 82.61C-4.313 68.23-.9688 48.25 13.41 37.97c14.34-10.27 34.38-6.922 44.63 7.453L192 232.1l133.1-187.5c10.28-14.37 30.28-17.7 44.63-7.453C384.1 48.25 388.3 68.23 378 82.61z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.openChartModal(element, 'yAxisPrimarySecondarySelection')
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.NORMALIZATION'),
        name: 'dataNormalization',
        val: 'dataNormalization',
        attr: 'dataNormalization', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 576,
          height: 512,
          // transform: 'translate(0, 0)',
          // path: 'M24 3.752l-4.423-3.752-7.771 9.039-7.647-9.008-4.159 4.278c2.285 2.885 5.284 5.903 8.362 8.708l-8.165 9.447 1.343 1.487c1.978-1.335 5.981-4.373 10.205-7.958 4.304 3.67 8.306 6.663 10.229 8.006l1.449-1.278-8.254-9.724c3.287-2.973 6.584-6.354 8.831-9.245z'
          // path: 'M416 208C416 253.9 401.1 296.3 375.1 330.7L502.6 457.4C515.1 469.9 515.1 490.1 502.6 502.6C490.1 515.1 469.9 515.1 457.4 502.6L330.7 375.1C296.3 401.1 253.9 416 208 416C93.12 416 0 322.9 0 208C0 93.12 93.12 0 208 0C322.9 0 416 93.12 416 208zM104 280C104 293.3 114.7 304 128 304C141.3 304 152 293.3 152 280V216C152 202.7 141.3 192 128 192C114.7 192 104 202.7 104 216V280zM184 280C184 293.3 194.7 304 208 304C221.3 304 232 293.3 232 280V120C232 106.7 221.3 96 208 96C194.7 96 184 106.7 184 120V280zM264 280C264 293.3 274.7 304 288 304C301.3 304 312 293.3 312 280V184C312 170.7 301.3 160 288 160C274.7 160 264 170.7 264 184V280z' // 돋보기
          path: 'M41.37 406.6C28.88 394.1 28.88 373.9 41.37 361.4C53.87 348.9 74.13 348.9 86.63 361.4L128 402.7V287.1H32C14.33 287.1 0 273.7 0 255.1C0 238.3 14.33 223.1 32 223.1H384V109.3L342.6 150.6C330.1 163.1 309.9 163.1 297.4 150.6C284.9 138.1 284.9 117.9 297.4 105.4L393.4 9.372C405.9-3.124 426.1-3.124 438.6 9.372L534.6 105.4C547.1 117.9 547.1 138.1 534.6 150.6C522.1 163.1 501.9 163.1 489.4 150.6L448 109.3V223.1H544C561.7 223.1 576 238.3 576 255.1C576 273.7 561.7 287.1 544 287.1H192V402.7L233.4 361.4C245.9 348.9 266.1 348.9 278.6 361.4C291.1 373.9 291.1 394.1 278.6 406.6L182.6 502.6C170.1 515.1 149.9 515.1 137.4 502.6L41.37 406.6zM128 63.1C128 46.33 142.3 31.1 160 31.1C177.7 31.1 192 46.33 192 63.1V191.1H128V63.1zM448 319.1V448C448 465.7 433.7 480 416 480C398.3 480 384 465.7 384 448V319.1H448z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          BriqueChart.onClickDataNormalization(this, ...arguments)
        }
      },
      {
        title: element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.LABEL.MODEBAR.HELP'),
        name: 'help',
        val: 'help',
        attr: 'help', // attr이 있어야 Plotly가 active를 잘 적용한다.
        icon: {
          width: 320,
          height: 512,
          path: 'M204.3 32.01H96c-52.94 0-96 43.06-96 96c0 17.67 14.31 31.1 32 31.1s32-14.32 32-31.1c0-17.64 14.34-32 32-32h108.3C232.8 96.01 256 119.2 256 147.8c0 19.72-10.97 37.47-30.5 47.33L127.8 252.4C117.1 258.2 112 268.7 112 280v40c0 17.67 14.31 31.99 32 31.99s32-14.32 32-31.99V298.3L256 251.3c39.47-19.75 64-59.42 64-103.5C320 83.95 268.1 32.01 204.3 32.01zM144 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S166.1 400 144 400z'
        },
        click: function (element, e) {
          BriqueChart.restyleModeBarButtons(element)
          // TODO: 추후 제거될 toast
          Toast.open({
            message: `Help에 대한 내용 정의 후 개발이 필요합니다.`,
            type: 'is-warning',
            queue: false
          })
          // BriqueChart.onClickDataNormalization(this, ...arguments)
        }
      }
    ]]
  },

  /**
   * Mode Bar Button Element들의 Style을 재지정한다.
   * @param {Object} element Chart의 Element
   */
  initModeBarButtons (element, modeBarButtons) {
    let layout = element.layout
    for (let btns of modeBarButtons) {
      for (let btn of btns) {
        element._fullLayout[btn.attr] = btn.attr// 이게 있어야 모드바 버튼의 Active가 잘 적용된다. inactive시 해제할 필요는 없음
        switch (btn.val) {
          case 'rangeView':
            if (!_.isUndefined(layout.xaxis.rangeslider)) {
              btn.active = true
            }
            break
        }
      }
    }
  },

  /**
   * Mode Bar Button의 visible에 따라 보이기 또는 숨기기
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  showHideModeBarButton (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    if (modeBarButton.visible === false) {
      BriqueChart.hideModeBarButton(element, modeBarButton)
    } else {
      BriqueChart.showModeBarButton(element, modeBarButton)
    }
  },

  /**
   * Mode Bar Button 보이기
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  showModeBarButton (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    btnElement.visible = true
    btnElement.style.display = 'inline'
  },

  /**
   * Mode Bar Button 숨기기
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  hideModeBarButton (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    btnElement.visible = false
    btnElement.style.display = 'none'
  },

  /**
   * Mode Bar Button의 아이콘을 설정한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   * @param {String} strPath 아이콘의 Path
   */
  setModeBarIcon (element, modeBarButton, strPath) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    modeBarButton.icon.path = strPath
    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    let svg = btnElement.querySelector('svg.icon')
    let strPathElement = `<path d='${strPath}'></path>`
    svg.innerHTML = strPathElement
  },

  /**
   * Mode Bar Button의 Title을 설정한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   * @param {String} title Mode Bar의 타이틀
   */
  setModeBarTitle (element, modeBarButton, title) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    modeBarButton.icon.title = title
    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    btnElement.setAttribute('data-title', title)
  },

  /**
   * Mode Bar Button의 Active Toggle
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  toggleModeBarButtonActive (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    modeBarButton.active = !modeBarButton.active

    // let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    // if (!btnElement) return

    setTimeout(function () {
      if (modeBarButton.active) BriqueChart.activeModeBarButton(element, modeBarButton)
      else BriqueChart.inactiveModeBarButton(element, modeBarButton)
    }, 51)
  },

  /**
   * Mode Bar Button을 Active 한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  activeModeBarButton (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    modeBarButton.active = true
    BriqueChart._activeModeBarButtonElement(element, modeBarButton)
  },

  /**
   * Mode Bar Button Element에 .active class를 추가한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  _activeModeBarButtonElement (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    setTimeout(function () {
      btnElement.classList.add('active')
    }, 51)
  },

  /**
   * Mode Bar Button을 Inactive 한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  inactiveModeBarButton (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    modeBarButton.active = false
    BriqueChart._inactiveModeBarButtonElement(element, modeBarButton)
  },

  /**
   * Mode Bar Button Element에 .active를 제거한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   */
  _inactiveModeBarButtonElement (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let btnElement = BriqueChart._getModeBarButtonElement(element, modeBarButton)
    if (!btnElement) return

    setTimeout(function () {
      btnElement.classList.remove('active')
    }, 51)
  },

  /**
   * Mode Bar Button의 HTML Element를 구한다.
   * @param {Object} element 차트 Element
   * @param {Object} modeBarButton Mode Bar Button Object
   * @returns Mode Bar Button의 HTML Element
   */
  _getModeBarButtonElement (element, modeBarButton) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    return element.querySelector(`.modebar-container .modebar-btn[data-val='${_.isFunction(modeBarButton.val) ? modeBarButton.val(element) : modeBarButton.val}']`)
  },

  /**
   * Mode Bar Button Object를 구한다.
   * @param {Object} element 차트 Element
   * @param {Striing} modeBarButtonVal Mode Bar Button의 val(Key)
   * @returns Mode Bar Button Object
   */
  getModeBarButton (element, modeBarButtonVal) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    let btn
    for (let modeBarButtons of (element._context?.modeBarButtons ?? [])) { // element._context.modeBarButtons가 이중배열로 되어 있다.
      btn = modeBarButtons.find(o => o.val === modeBarButtonVal)
      if (btn) break
    }

    return btn
  },

  /**
   * Mode Bar Button Element의 Style을 재지정한다.
   * @param {Object} element Chart의 Element
   */
  restyleModeBarButtons (element) {
    BriqueChart._restyleModeBarButtonElements(element)
  },

  /**
   * Mode Bar Button Element의 Style을 재지정한다.
   * @param {Object} element Chart의 Element
   */
  _restyleModeBarButtonElements (element) {
    if (_.isString(element)) element = document.querySelector(`#${element}`)

    if (element._context.displayModeBar) {
      for (let btns of element._context.modeBarButtons) {
        for (let btn of btns) {
          if (btn.visible === false) {
            BriqueChart.hideModeBarButton(element, btn)
            continue
          }

          switch (btn.val) {
            case 'samplingData':
              if (element.briqueChartData.isSampling === true) {
                BriqueChart.activeModeBarButton(element, btn) // active
                BriqueChart.setModeBarTitle(element, btn, element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_SHOW_SAMPLING_DATA'))
              } else {
                BriqueChart.inactiveModeBarButton(element, btn)
                BriqueChart.setModeBarTitle(element, btn, element.parentElement.__vue__.$t('fdc.CHART_COMPONENT.MESSAGE.INFORM_SHOW_ALL_DATA'))
              }
              break
            case 'dataNormalization':
              if (element.briqueChartData.isDataNormalization === true) {
                BriqueChart.activeModeBarButton(element, btn) // active
              } else {
                BriqueChart.inactiveModeBarButton(element, btn)
              }
              break
            default:
              if (btn.active === true) {
                BriqueChart.activeModeBarButton(element, btn) // active
              } else if (btn.active === false) {
                BriqueChart.inactiveModeBarButton(element, btn)
              }
          }
        }
      }
    }
  }
}
